import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import pushModel from "@/mixin/store/api/pushModel";
import axios from "@/plugins/axios";
import deleteModel from "@/mixin/store/api/deleteModel";
import changeModel from "@/mixin/store/api/changeModel";

export default {
    actions: {
        fetchIncomeAndOutcomes(context, search) {
            return fetchModels(context, 'income_and_outcomes', search.page + '&order[id]=desc', 'updateIncomeAndOutcomes');
        },
        fetchIncomeAndOutcome(context, id) {
            return fetchModel(context, 'income_and_outcomes', id, 'updateIncomeAndOutcome');
        },
        putIncomeAndOutcome(context, data) {
            return changeModel(context, 'income_and_outcomes/' + data.id + '/rewrite', data, 'updateIncomeAndOutcome')
        },
        pushIncomeAndOutcome(context, data) {
            return pushModel(context, 'income_and_outcomes', data)
        },
        deleteIncomeAndOutcome(context, id) {
            return deleteModel(context, 'income_and_outcomes', id);
        },
        fetchIncomeAndOutcomeReport(context, date = null) {
            return pushModel(context, 'income_and_outcomes/report', date, 'updateIncomeAndOutcomesReport')
        },
        searchIncomeAndOutcome(context, searchItem) {
            let url = "income_and_outcomes?page=" + searchItem.page;
            let isSearch = false;

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
                isSearch = true
            }

            if (searchItem.isIncome !== null) {
                url = url + '&isIncome=' + searchItem.isIncome
                isSearch = true
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
                isSearch = true
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateIncomeAndOutcomes', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateIncomeAndOutcomesReport(state, data) {
            state.incomeAndOutcomesReport.models = data
        },
        updateIncomeAndOutcomes(state, data) {
            state.incomeAndOutcomes = data
        },
        updateIncomeAndOutcome(state, data) {
            state.incomeAndOutcome = data
        },
    },
    state: {
        incomeAndOutcomes: {
            models: [],
            totalItems: 0,
        },
        incomeAndOutcomesReport: {
            models: [],
        },
        incomeAndOutcome: {
            id: null,
            isIncome: true,
            reason: null,
            sum: null,
            sumCurrency: {},
            createAt: null
        }
    },
    getters: {
        getIncomeAndOutcomes(state) {
            return state.incomeAndOutcomes.models
        },
        getIncomeAndOutcomesTotalCount(state) {
            return state.incomeAndOutcomes.totalItems
        },
        getIncomeAndOutcome(state) {
            return state.incomeAndOutcome
        },
        getIAOReport(state) {
            return state.incomeAndOutcomesReport.models
        },
    },
}